import AnnouncementsIcon from '@/resources/AnnouncementsIcon';
import EventsIcon from '@/resources/EventsIcon';
import PollsIcon from '@/resources/PollsIcon';
import ReportIcon from '@/resources/ReportsIcon';
import React from 'react';
import { translate } from '@/services/TranslationService';
import { Typography } from '@/components/novoville';

const NoMessages = ({ type }) => {
  let icon = null;
  let titleKey = '';
  let bodyKey = '';

  switch (type) {
    case 'announcements':
    case 'ANNOUNCEMENT':
      icon = <AnnouncementsIcon />;
      titleKey = 'NoAnnouncementsTitle';
      bodyKey = 'NoAnnouncementsBody';
      break;
    case 'events':
    case 'EVENT':
      icon = <EventsIcon />;
      titleKey = 'NoEventsTitle';
      bodyKey = 'NoEventsBody';
      break;
    case 'polls':
    case 'POLL':
      icon = <PollsIcon />;
      titleKey = 'NoPollsTitle';
      bodyKey = 'NoPollsBody';
      break;
    case 'REPORTS':
      icon = <ReportIcon />;
      titleKey = 'NoReportsTitle';
      bodyKey = 'NoReportsBody';
      break;
    default:
      return null;
  }

  return (
    <div className="flex flex-col flex-1 justify-center items-center text-center">
      <div className="w-[140px] h-[140px]">{icon}</div>
      <Typography variant="semibold_18" className="text-gray-700 pt-[24px]">
        {translate(titleKey)}
      </Typography>
      <Typography variant="regular_16" className="text-gray-700">
        {translate(bodyKey)}
      </Typography>
    </div>
  );
};

export default NoMessages;
